import { Injectable, OnDestroy, Output } from '@angular/core';
import { Observable } from 'rxjs';

import { ActivePage, RenderingContext } from './../../../api';
import {
  pageDisposeActivePage,
  pageGetActivePage
} from './../../utils/page.utils';

/* Copyright IBM Corp. 2017 */
/*
 * Implementation of a service that gives access to the rendering
 * context of the currently selected page.
 */
@Injectable({ providedIn: 'root' })
export class ActivePageService implements ActivePage, OnDestroy {
  /*
     * Retrieves the rendering context for the content item rendered for the
     * currently selected page.
     */
  @Output()
  get onRenderingContext(): Observable<RenderingContext> {
    return pageGetActivePage();
  }

  /*
     * Potentially called when the service falls out of scope
     */
  ngOnDestroy(): void {
    pageDisposeActivePage();
  }
}
